var Curriculog = Curriculog || {};

Curriculog.ManageUserRolesView = (function ($, _, Backbone, ManageUserRolesView) {

    ManageUserRolesView = Curriculog.CurriculogView.extend({
        template: 'HierarchyFlyout/manageUserRoles.html',
        events: {
            'click #add-role': 'addRole',
            'click #entities-available': 'change',
        },

        initialize: function (options) {
            this.userID = options.userID;
            this.roles = options.roles;
            this.entities = options.entities;
            this.userRoles = options.userRoles;
            this.committees = options.committees;
            this.agendaAdmins = options.agendaAdmins;
            this.relationships = options.relationships;
            this.params = options.params;
            this.listenTo(this.userRoles, 'add', this.render);
            this.listenTo(this.userRoles, 'remove', this.render);
            this.listenTo(this.userRoles, 'reset', this.render);
            this.render();
        },

        render: function () {
            this.el = nunjucks.render(this.template);
            this.replaceElement(this.el);
            this.renderEntityDropdown();
            this.renderRoleDropdown();
            this.renderRoleList();
            this.renderCommitteeList();
        },

        renderEntityDropdown: function () {
            var subView = new Curriculog.HierarchyDropdownView({
                id: 'entities-available',
                collection: this.relationships,
                entities: this.entities,
            });

            var entityLabel = $(this.$el).find('label')[0];
            $(subView.el).insertAfter(entityLabel);
            this.entityDropdown = subView;
        },

        renderRoleDropdown: function () {
            var view = this;
            var entityID = this.entityDropdown.getCurrentSelection();
            var roles = this.roles.getRoleModelsForEntity(parseInt(entityID));
            var rolesForDropdown = [];

            roles.forEach(function (item, index) {
                var roleID = item.get('id');
                var users = view.userRoles.getUsersForRole(roleID);

                if (users.indexOf(view.userID) < 0) {
                    rolesForDropdown.push(item);
                }
            });

            var roleDropdownCollection = new Curriculog.SortableCollecion(rolesForDropdown);
            var subView = new Curriculog.DropdownView({
                collection: roleDropdownCollection,
                id: 'entity-roles-available',
                noAvailableOptionsMessage: 'No Roles Available',
            });
            var rolesLabel = $(this.$el).find('label')[1];
            $(subView.el).insertAfter(rolesLabel);
            this.roleDropdown = subView;
        },

        renderRoleList: function () {
            var roleIDs = this.userRoles.getRolesForUser(this.userID);
            var roles = this.roles.getManyRoleObjects(roleIDs);
            var view = this;

            roles.forEach(function (item, index) {
                var entity = view.entities.get(item['entity_id']);
                item['entityName'] = entity.get('name');

                var committeeID = item['committee_id'];
                if (committeeID !== null) {
                    var committee = view.committees.get(committeeID)
                    item['committee'] = committee.toJSON();
                } else {
                    item['committee'] = null;
                }
            });

            var subView = new Curriculog.UserRoleListView({
                items: roles,
                userID: this.userID,
                params: this.params
            });

            var rolesLabel = $(this.$el).find('.label')[0];
            $(subView.el).insertAfter(rolesLabel);
            this.roleList = subView;
        },

        renderCommitteeList: function () {
            var userCommittees = [];
            var userIsAgendaAdmin = false;

            for (var i = 0; i < this.roleList.items.length; i++) {
                var committeeID = this.roleList.items[i]['committee_id'];
                if (committeeID !== null) {
                    var committee = this.committees.get(committeeID);
                    var committeeClone = committee.clone().toJSON();

                    if (this.agendaAdmins.isAgendaAdmin(committee.get('id'), this.userID)) {
                        committeeClone['isAgendaAdmin'] = true;
                        userIsAgendaAdmin = true;
                    } else {
                        committeeClone['isAgendaAdmin'] = false;
                    }

                    userCommittees.push(committeeClone);
                }
            }

            var subView = new Curriculog.CommitteeListView({
                items: userCommittees,
                userID: this.userID,
            });

            var committeesLabel = $(this.$el).find('.label')[1];
            $(subView.el).insertAfter(committeesLabel);
            this.committeeList = subView;
        },

        addRole: function () {

        },

        change: function () {
            this.roleDropdown.remove();
            this.renderRoleDropdown();
        },
    });
    return ManageUserRolesView;


})($, _, Backbone, Curriculog.ManageUserRolesView || {});
